import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-datenschutz',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  templateUrl: './datenschutz.component.html',
  styleUrl: './datenschutz.component.scss',
})
export class DatenschutzComponent implements OnInit, OnDestroy {
  private readonly pageTitle = 'Datenschutzerklärung | Rast-WC.de';
  private readonly pageDescription =
    'Erfahre, welche Daten wir verarbeiten: Konto, Bewertungen, Favoriten, technisch notwendige Cookies/LocalStorage, Server-Logs und Kartenkacheln. Deine Privatsphäre hat Priorität.';

  constructor(
    private title: Title,
    private seo: SeoService,
    @Inject(DOCUMENT) private doc: Document,
  ) {}

  ngOnInit(): void {
    this.title.setTitle(this.pageTitle);
    this.seo.updateMetaDescription(this.pageDescription);
    this.setCanonical(this.doc.location?.origin + '/datenschutz');
  }

  ngOnDestroy(): void {
    this.seo.resetMetaDescription();
  }

  private setCanonical(href: string | undefined) {
    if (!href) return;
    let link: HTMLLinkElement | null = this.doc.querySelector('link[rel="canonical"]');
    if (!link) {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(link);
    }
    link.setAttribute('href', href);
  }
}
